import React from 'react';
import PropTypes from 'prop-types';
import { CircleButtonCard } from '../index';
import './landing_card.scss';

// Default Landing Card Style for Menu Landing Pages

export const LandingCard = ({
    body,
    className = '',
    disabled = false,
    href,
    to,
    onClick,
    target,
    title,
}) => {

    const landingCardClasses = [
        `mybswh-landing-card`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <CircleButtonCard
            titleStyle={{ bold: true, type: "heading-02" }}
            arrowIcon={{ colorStyle: "float" }}
            className={landingCardClasses}
            disabled={disabled}
            href={href}
            target={target}
            to={to}
            onClick={onClick}
            title={title}
            body={body}
        />
    )
};

LandingCard.propTypes = {
    body: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    to: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func
    ]),
    onClick: PropTypes.func,
    target: PropTypes.string,
    title: PropTypes.string,
}